(() => {
	// Test identifier
	const testId = "DLT-002";

	// Select the original Buy Now and Add to Cart buttons from the product page
	const originalBuyNowButton = document.querySelector(".product__main__content .product__block__buttons button.shopify-payment-button__button");
	const originalAddToCartButton = document.querySelector(".product__main__content .product__block__buttons button.btn--add-to-cart");

	// Insert the new sticky buttons HTML at the end of the body element
	// These buttons will remain visible as the user scrolls down the page
	document.body.insertAdjacentHTML(
		"beforeend",
		`
			<div class="${testId}-sticky-buttons">
				<button class="${testId}-sticky-buttons-add-to-cart">${originalAddToCartButton.innerHTML}</button>
				<button class="${testId}-sticky-buttons-buy-now">${originalBuyNowButton.innerHTML}</button>
			</div>
		`
	);

	// Select the newly created sticky buttons for event handling
	const stickyAddToCartButton = document.querySelector(`.${testId}-sticky-buttons-add-to-cart`);
	const stickyBuyNowButton = document.querySelector(`.${testId}-sticky-buttons-buy-now`);

	// Add click event listener to the sticky Add to Cart button
	// When clicked, it triggers a click on the original Add to Cart button
	stickyAddToCartButton.addEventListener("click", () => {
		originalAddToCartButton.click();
	});

	// Add click event listener to the sticky Buy Now button
	// When clicked, it triggers a click on the original Buy Now button
	stickyBuyNowButton.addEventListener("click", () => {
		originalBuyNowButton.click();
	});
})();
